import { useAppDispatch, useAppSelector } from '../../../hooks/useRedux';
import classNames from 'classnames/bind';
import styles from './Cover.module.css';

import toast from 'react-hot-toast';

import { useSlice } from '../../../hooks/useSlice';
import { usePage } from '../../../hooks/usePage';

import { selectMenu } from '../../../features/infoSlice';
import { useAddSharedLibraryMutation } from '../../../services/search';
import { useDelSharedProjectMutation } from '../../../services/share';

import { Options } from '../../../types/library';

import {
  EBOOK_COVER,
  REGISTERED_SHARED_LIBRARY,
  SHARED_EBOOK,
  SHARING_ENDED,
} from '../../../constants';
import { getThumbnail } from '../../../utils/image';

export default function Cover() {
  const cx = classNames.bind(styles);
  const menu = useAppSelector(selectMenu);
  const dispatch = useAppDispatch();

  const { initPageList, pageChanged } = usePage();
  const { selectSingleItem, selectOptions } = useSlice();

  const item: any = useAppSelector(selectSingleItem);
  const { sortType, sortOrder }: Options = useAppSelector(selectOptions);

  const coverFilePath =
    item?.project?.coverFilePath || item?.resource?.coverFilePath;
  const cover =
    coverFilePath ||
    getThumbnail(
      item?.project?.ext ??
        item?.resource?.ext ??
        item?.projectResource?.ext ??
        'folder'
    );
  const isEndSharing = menu === 'share' && !!item?.projectShare?.expYn;

  const [addSharedLibrary] = useAddSharedLibraryMutation();
  const [delSharedLibrary] = useDelSharedProjectMutation();

  const toggleSharedLib = async () => {
    const { isShare, project } = item;
    const { projectId } = project;

    try {
      if (!isShare) {
        await addSharedLibrary(projectId).unwrap();
        toast(REGISTERED_SHARED_LIBRARY);
      } else {
        await delSharedLibrary({
          projectList: [{ projectId }],
        }).unwrap();
      }
    } catch (error) {
      console.error('Failed to toggle shared library', error);
    }

    dispatch(pageChanged(0));
    dispatch(
      initPageList({
        page: 0,
        sortBy: sortType,
        sortDir: sortOrder,
        projectId,
      })
    );
  };

  return (
    <div className={cx('panel')}>
      <div className={cx('panel_title', 'blind')}>
        <span>{EBOOK_COVER}</span>
      </div>
      <div className={cx('panel_inner')}>
        <div className={cx('panel_row')}>
          <span className={cx('detail')}>
            <span
              className={cx('panel_cover', {
                ebook: menu !== 'mydrive' && menu !== 'trash',
              })}
            >
              <img src={cover} alt={item?.title} />
              {menu === 'share' && isEndSharing && (
                <span className={cx('marker', { end: isEndSharing })}>
                  <span>{SHARING_ENDED}</span>
                </span>
              )}
              {menu === 'search' && (
                <span
                  className={cx('register', { on: item?.isShare })}
                  onClick={toggleSharedLib}
                >
                  {SHARED_EBOOK}
                </span>
              )}
            </span>
          </span>
        </div>
      </div>
    </div>
  );
}
